import * as React from 'react';
import ToggleButton from 'react-toggle-button'

export interface IToggleSwitchProps {
    onToggle: (value: boolean) => void;
    value: boolean;
    selectedColor: string;
    roleForTest?: string;
}

export const ToggleSwitch: React.FC<IToggleSwitchProps> = (props) => {

    return <><ToggleButton value={props.value}
        inactiveLabel={''}
        activeLabel={''}
        trackStyle={{
            width: "35px",
            height: "13px",
        }}
        colors={{
            active: {
                base: props.selectedColor
            },
            inactive: {
                base: 'rgb(111, 111, 111)',
            }
        }}
        thumbAnimateRange={[0, 17]}
        onToggle={(value: boolean) => {
            props.onToggle(!value);
        }}
    />
        {props.roleForTest && <button onClick={() => {
            props.onToggle(!props.value);
        }} data-test-role={props.roleForTest} style={{ display: "none" }} ></button>
        }
    </>
}








